import React, { Fragment, PureComponent } from 'react'
import { testReports, testWhenNoReports } from '../tests'
import { xmlToJson } from '../utils'

import Error from './Error'
import { Button, Container, P } from '../primitives'

class Result extends PureComponent {
	constructor(props) {
		super(props)

		const xml = new DOMParser().parseFromString(this.props.text, 'text/xml')
		const json = xmlToJson(xml)
		const foundTypes = {}

        if (json && json.root) {
            if (json.root.report) {
				const reports = [].concat(json.root.report || []);
				var unknownErrors = 0

				this.errors = reports.reduce((accumulator1, report) => {
					var foundErrors = false
					var foundNonErrors = 0

					const testsResults = testReports.reduce((accumulator2, test) => {
						const error = test(report)

						if (error) {
							if (!error.nonError) {
								foundErrors = true
							}

							if (!foundTypes[error.type]) {
								foundTypes[error.type] = true

								if (error.nonError) {
									foundNonErrors += 1
								}

								return [...accumulator2, error]
							}
						}

						return accumulator2
					}, [])

					if (testsResults.length > 0) {
						if (foundNonErrors >= testsResults.length) {
							unknownErrors += 1
						}

						return [...accumulator1, ...testsResults]
					} else if (!foundErrors) {
						unknownErrors += 1
					}

					return accumulator1
				}, [])

				for (var i = 0; i < unknownErrors; i++) {
					this.errors.push(
					{
						type: 'unkownError',
						color: 'Silver',
						title: 'Unknown Error',
						text: 'An error in your file has not been recognized.',
						description: '<strong>If other errors were recognized, try focusing on them first. Unknown errors are often related to the recognized errors.</strong><br/><br/>' +
						'Perhaps we haven\'t updated our database yet, or you\'re experiencing issues that we have never heard of before.' +
						'<br/>It\'s best to send your lastException file to a mod creator or a support community to receive better help.</br></br>' +
						'<strong>Please note, that if you\'re not experiencing any noticeable issues in your game, then it\'s very likely they are not a reason to stop playing.</strong>'
					}
					)
				}
			} else {
				this.errors = testWhenNoReports.reduce((accumulator, test) => {
					const error = test(json)

					if (error && !foundTypes[error.type]) {
						foundTypes[error.type] = true
						return [...accumulator, error]
					}

					return accumulator
				}, [])
			}
		} else {
			this.invalid = true
		}
	}

	render() {
		const content = this.invalid ? (
			<P margin={10}>
				Looks like something went wrong with your error file!
				<br/><br/>
				- If you're pasting text, make sure you've selected everything in the file.<br/>
				- If you're uploading a file, make sure it's the right file!<br/>
				<br/>
				Only '<strong>lastException</strong>' files are allowed!
			</P>
		) : this.errors.length ? (
			<Fragment>
				<P margin={10} center>
					Here are the errors we were able to recognize from your lastException file.
				</P>
				<P margin={10} center>
					<strong>Click on the results to display more information!</strong>
				</P>
				{this.errors.map((error, i) => <Error key={i} {...error} />)}
			</Fragment>
		) : (
			<P margin={10}>
				We were not able to recognise any of the errors in your file.<br/><br/>
				Perhaps we haven't updated our database yet, or you're experiencing issues that we have never heard of before.<br/><br/>
				It's best to send your lastException file to a mod creator or a support community to receive better help.
			</P>
		)

		return (
			<Container>
				<Button onClick={this.props.reset}>Upload Another lastException File</Button>
				{content}
			</Container>
		)
	}
}

export default Result



// WEBPACK FOOTER //
// ./src/components/Result.js